export default "__VITE_ASSET__dCv2_d8f__"